import classnames from 'classnames';
import * as React from 'react';
import './styles/AppHeader.scss';

type AppHeaderProps = React.PropsWithChildren<{
    className?: string;
}>;

function AppHeader({ className, children }: AppHeaderProps) {
    const classes = classnames('palette-app-header', className);

    return (
        <header className={classes}>
            {children}
        </header>
    );
}

export default AppHeader;
